import { Capacitor } from "@capacitor/core";

function getHostname(): string {
  return typeof window !== 'undefined' ? window.location.hostname : '';
}

export function getIsNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * @deprecated No longer used — ShiftCanvas has its own Kinde auth and is not a satellite.
 * Kept for backwards compatibility but always returns false.
 */
export function getIsSatelliteDomain(): boolean {
  return false;
}

export function getIsPrimaryDomain(): boolean {
  const hostname = getHostname();
  return hostname.includes('centretable.com.au') || hostname.includes('shiftcanvas.com.au');
}

export function getIsDev(): boolean {
  return import.meta.env.DEV === true;
}

export function getIsProductionDomain(): boolean {
  const hostname = getHostname();
  return (
    hostname.includes("centretable.com.au") ||
    hostname.includes("shiftcanvas.com.au")
  );
}

export function getIsShiftCanvasDomain(): boolean {
  const hostname = getHostname();
  return hostname.includes('shiftcanvas.com.au');
}

export function getIsCentreTableDomain(): boolean {
  const hostname = getHostname();
  return hostname.includes('centretable.com.au');
}

export const isNativePlatform = getIsNativePlatform();
/** @deprecated Always false — satellite concept removed */
export const isSatelliteDomain = false;
export const isPrimaryDomain = getIsPrimaryDomain();
/** @deprecated Use isDev instead */
export const isReplitDev = getIsDev();
export const isDev = getIsDev();
export const isProductionDomain = getIsProductionDomain();

export function getCurrentBrand(): 'centretable' | 'shiftcanvas' {
  // Native apps always use shiftcanvas brand
  if (getIsNativePlatform()) {
    return 'shiftcanvas';
  }

  const hostname = getHostname();

  // Check if on ShiftCanvas domain
  if (hostname.includes('shiftcanvas')) {
    return 'shiftcanvas';
  }

  // Default to centretable
  return 'centretable';
}
